import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
  instalacion: undefined,
  usuario: undefined,
  supervisorPicking: undefined,
  sucursal: undefined,
  resultadoAutenticacion: {
    error: undefined,
    autenticado: false,
    restablecerContrasenia: false,
  },
  estilosInterno: null,
  estilosOnline: null,
})

export default function sessionReducer(state = initialState, action) {
  if (action.type === ReducerActions.INITIALIZE_FORM) {
    return state
      .set('usuario', initialState.get('usuario'))
      .set('resultadoAutenticacion', initialState.get('resultadoAutenticacion'))
  }

  if (action.type === ReducerActions.SAVE_INSTALACION) {
    let myState = fromJS(action.payload)
    return state.set('instalacion', myState)
  }

  if (action.type === ReducerActions.SAVE_DEFAULT_RESULTADO_AUTENTICACION) {
    return state.set(
      'resultadoAutenticacion',
      initialState.get('resultadoAutenticacion')
    )
  }

  if (action.type === ReducerActions.SAVE_RESULTADO_AUTENTICACION) {
    let myState = state.toJS()

    return fromJS({
      ...myState,
      resultadoAutenticacion: {
        ...myState.resultadoAutenticacion,
        ...action.payload,
      },
    })
  }

  if (action.type === ReducerActions.SAVE_USUARIO) {
    return state.set('usuario', fromJS(action.payload))
  }

  if (action.type === ReducerActions.SAVE_SUCURSAL) {
    return state.set('sucursal', action.payload)
  }

  if (action.type === ReducerActions.SAVE_IMAGEN_LOGIN) {
    let myState = state.toJS()

    let myInstalacion = { ...myState.instalacion }
    myInstalacion.fondoLogin = action.payload

    return fromJS({
      ...myState,
      instalacion: myInstalacion,
    })
  }

  if (action.type === ReducerActions.SAVE_CLAVE_SUPERVISOR_PICKING) {
    let myStateSupervisor = fromJS(action.payload)
    return state.set('supervisorPicking', myStateSupervisor)
  }

  if (action.type === ReducerActions.SET_ESTILOS_INTERNO) {
    return state.set('estilosInterno', fromJS(action.payload))
  }

  if (action.type === ReducerActions.SET_ESTILOS_ONLINE) {
    return state.set('estilosOnline', fromJS(action.payload))
  }

  return state
}
